module.exports = __webpack_public_path__ + "img/lily white_sc2.cbd87dd8.png";